import { Check } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { IMAGES } from "@/lib/content";

const POINTS = [
  "Dubbellaags ZOAB (stil asfalt) kan verkeersgeluid aantoonbaar reduceren.",
  "Onderhoud en kwaliteit van het wegdek spelen een belangrijke rol in het effect.",
  "Snelheid beïnvloedt eveneens het geluid van personenauto's — met name via band-wegdekgeluid.",
  "Maatregelen kunnen elkaar aanvullen: stiller asfalt én een lagere snelheid versterken elkaar.",
  "80 km/u hoeft dus geen alternatief voor stiller asfalt te zijn, maar kan onderdeel zijn van een combinatie van maatregelen.",
];

export const Asphalt = () => (
  <section id="asfalt" data-testid="asphalt-section" className="scroll-mt-24 border-t border-gooi-green/10 py-24 md:py-32">
    <div className="mx-auto max-w-[90rem] px-5 md:px-12">
      <div className="grid items-center gap-14 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <Overline>Nuancering</Overline>
            <h2 className="mt-4 max-w-2xl font-display text-3xl font-medium leading-tight tracking-tight text-gooi-green md:text-5xl">
              Stil asfalt helpt. Maar snelheid blijft ertoe doen.
            </h2>
          </Reveal>
          <ul className="mt-10 space-y-5">
            {POINTS.map((point, i) => (
              <Reveal key={point} delay={i * 0.08}>
                <li className="flex items-start gap-4">
                  <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gooi-sand">
                    <Check className="h-3.5 w-3.5 text-gooi-forest" strokeWidth={2} aria-hidden="true" />
                  </span>
                  <p className="text-base leading-relaxed text-gooi-green/80">{point}</p>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div className="photo-frame aspect-square shadow-xl shadow-gooi-green/10">
              <img
                src={IMAGES.asphalt}
                alt="Luchtfoto van het wegdek van de A1 tussen groen"
                loading="lazy"
                className="duotone-photo h-full w-full object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
